/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindCertificatesQueryResponse,
  FindCertificatesQueryParams,
} from "../types/FindCertificates.ts"

export const findCertificatesQueryKey = (params: FindCertificatesQueryParams) =>
  [
    { url: "/v1/certificate/find-certificates" },
    ...(params ? [params] : []),
  ] as const

export type FindCertificatesQueryKey = ReturnType<
  typeof findCertificatesQueryKey
>

/**
 * @summary Find certificates
 * {@link /v1/certificate/find-certificates}
 */
export async function findCertificates(
  params: FindCertificatesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindCertificatesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/certificate/find-certificates`,
    params,
    ...requestConfig,
  })
  return res
}

export function findCertificatesQueryOptions(
  params: FindCertificatesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findCertificatesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindCertificatesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindCertificatesQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findCertificates(params, config)
    },
  })
}

/**
 * @summary Find certificates
 * {@link /v1/certificate/find-certificates}
 */
export function useFindCertificates<
  TData = ResponseConfig<FindCertificatesQueryResponse>,
  TQueryData = ResponseConfig<FindCertificatesQueryResponse>,
  TQueryKey extends QueryKey = FindCertificatesQueryKey,
>(
  params: FindCertificatesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindCertificatesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? findCertificatesQueryKey(params)

  const query = useQuery(
    {
      ...findCertificatesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
